const DisclaimerIcon = ({ color = 'currentColor' }) => {
  return (
    <svg
      width="45"
      height="50"
      viewBox="0 0 45 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.0395 10.7122C23.7395 7.5608 28.2605 7.5608 29.9605 10.7122L42.4232 33.815C44.0405 36.8132 41.8692 40.4515 38.4627 40.4515H13.5373C10.1308 40.4515 7.95951 36.8132 9.57683 33.815L22.0395 10.7122Z"
        stroke={color}
        strokeWidth="3"
      />
      <path
        d="M26.6832 18.4053V24.6949C26.6832 25.362 26.6535 26.0181 26.5941 26.6632C26.5347 27.301 26.4554 27.9791 26.3564 28.6975H24.703C24.604 27.9791 24.5248 27.301 24.4653 26.6632C24.4059 26.0181 24.3762 25.362 24.3762 24.6949V18.4053H26.6832ZM24 32.8099C24 32.5827 24.0363 32.3664 24.1089 32.1612C24.1881 31.9559 24.2937 31.78 24.4257 31.6334C24.5644 31.4868 24.7261 31.3695 24.9109 31.2815C25.0957 31.1935 25.2937 31.1496 25.505 31.1496C25.7096 31.1496 25.9043 31.1935 26.0891 31.2815C26.2739 31.3695 26.4323 31.4868 26.5644 31.6334C26.6964 31.78 26.802 31.9559 26.8812 32.1612C26.9604 32.3664 27 32.5827 27 32.8099C27 33.0445 26.9604 33.2644 26.8812 33.4697C26.802 33.6676 26.6964 33.8399 26.5644 33.9865C26.4323 34.1331 26.2739 34.2467 26.0891 34.3274C25.9043 34.4153 25.7096 34.4593 25.505 34.4593C25.2937 34.4593 25.0957 34.4153 24.9109 34.3274C24.7261 34.2467 24.5644 34.1331 24.4257 33.9865C24.2937 33.8399 24.1881 33.6676 24.1089 33.4697C24.0363 33.2644 24 33.0445 24 32.8099Z"
        fill={color}
      />
    </svg>
  );
};

export default DisclaimerIcon;
